import { render, staticRenderFns } from "./JobMobileCardSkeleton.vue?vue&type=template&id=73a07489&scoped=true&"
import script from "./JobMobileCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./JobMobileCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./JobMobileCardSkeleton.vue?vue&type=style&index=0&id=73a07489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a07489",
  null
  
)

export default component.exports